import * as React from "react";
import { toast } from "sonner";

import type {
	MaterialOption,
	PurchaseFormValues,
	PurchaseResource,
	SupplierOption,
} from "../types";
import { useCreatePurchaseMutation } from "../hooks/useCreatePurchaseMutation";
import { PurchasesForm } from "./PurchasesForm";
import {
	DEFAULT_VALUES,
	buildPurchasePayload,
	usePurchasesForm,
} from "./usePurchasesForm";

type PurchasesCreateFormControllerProps = {
	open: boolean;
	defaultValues: PurchaseFormValues;
	disableMaterial: boolean;
	supplierOption: SupplierOption | null;
	materialOption: MaterialOption | null;
	onRequestNewSupplier: () => void;
	onRequestNewMaterial: () => void;
	onClose: () => void;
	onCancel: () => void;
	onCreated: (purchase: PurchaseResource) => void;
};

export const PurchasesCreateFormController: React.FC<
	PurchasesCreateFormControllerProps
> = ({
	open,
	defaultValues,
	disableMaterial,
	supplierOption,
	materialOption,
	onRequestNewSupplier,
	onRequestNewMaterial,
	onClose,
	onCancel,
	onCreated,
}) => {
	const { form, resetToInitialValues, querySuppliers, queryMaterials } =
		usePurchasesForm({ defaultValues });

	const { mutateAsync: createPurchase, isPending } =
		useCreatePurchaseMutation();

	const handleSubmit = form.handleSubmit(async (values) => {
		try {
			const payload = buildPurchasePayload({
				...DEFAULT_VALUES,
				...values,
			});

			const purchase = await createPurchase(payload);
			toast.success("Compra efetuada.");
			onCreated(purchase);

			onClose();
		} catch (error) {
			toast.error("Não foi possível guardar a compra. Tente novamente.");
		}
	});

	const handleCancel = () => {
		onCancel();
		onClose();
		resetToInitialValues();
	};

	return (
		<PurchasesForm
			open={open}
			form={form}
			isSubmitting={isPending}
			supplierOption={supplierOption}
			onSupplierQuery={querySuppliers}
			onRequestNewSupplier={onRequestNewSupplier}
			materialOption={materialOption}
			onMaterialQuery={queryMaterials}
			onRequestNewMaterial={onRequestNewMaterial}
			disableMaterial={disableMaterial}
			onSubmit={handleSubmit}
			onCancel={handleCancel}
			onClose={onClose}
		/>
	);
};
